import React from 'react'
import Input from '../../UI/Input/Input'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import { updateObject, checkValidity } from '../../../shared/utility'
import './TariffShiftValueForm.css'
import Fade from 'react-reveal/Fade'
import FetchData from '../../../shared/fetchData'
import Select from '../../UI/Select/Select'
import Modal from '../../UI/Modal/Modal'
import TimePicker from "../../UI/TimePicker/TimePicker";

const TariffShiftValueForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [invalidSelect, setInvalidSelect] = React.useState(false)
    const [id, setId] = React.useState('')
    const [shifts, setShifts] = React.useState(props.shifts)
    const [shift, setShift] = React.useState('')
    const [zones, setZones] = React.useState(props.zones)
    const [zone, setZone] = React.useState('')
    const [tariffId, setTariffId] = React.useState('')
    const [startTime, setStartTime] = React.useState('00:00')
    const [endTime, setEndTime] = React.useState('00:00')
    const [invalidTime, setInvalidTime] = React.useState(false)
    const [lockerTypes, setLockerTypes] = React.useState(props.lockerTypes)
    const [lockerType, setLockerType] = React.useState('')
    const [tariffShiftValue, setTariffValue] = React.useState({
        value: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'مقدار'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        diff: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'اختلاف روز'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })

    const childRef = React.useRef()

    React.useEffect(() => {
        setTariffId(props.tariffId)
        if (props.edit == true) {
            const lckTp = props.lockerTypes != null && props.lockerTypes.length != 0 ?
                props.lockerTypes.filter(l => l.id == props.tariffShiftValue.lockerType != null ? props.tariffShiftValue.lockerType.id : 0) : []
            if (lckTp != null && lckTp.length != 0) {
                setLockerType({
                    value: lckTp[0].id,
                    label: lckTp[0].description
                })
            }
            const lckrTp = tariffShiftValue
            lckrTp.value.value = props.tariffShiftValue.value
            lckrTp.diff.value = props.tariffShiftValue.diff
            setStartTime(props.tariffShiftValue.startTime);
            setEndTime(props.tariffShiftValue.endTime);
            setTariffValue(lckrTp)
            setEdit(true)
            setId(props.tariffShiftValue.id)
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        let val = controlName == 'value' ? event.target.value.toString().replace(/[^0-9]/g, "") : event.target.value
        let value = controlName == 'value' ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : val
        const updatedControls = updateObject(tariffShiftValue, {
            [controlName]: updateObject(tariffShiftValue[controlName], {
                value: value
            })
        });
        setTariffValue(updatedControls)
    }

    const tariffShiftValueSubmit = (event) => {
        const tv = tariffShiftValue
        let valid = true
        for (let key in tv) {
            if (tv[key].value == '') {
                valid = false
                tv[key].valid = false
            }
        }
        if (lockerType == null || lockerType == '') {
            valid = false
            setInvalidSelect(true)
        }
        if (startTime == null || startTime == '') {
            valid = false
            setInvalidTime(true)
        }
        if (endTime == null || endTime == '') {
            valid = false
            setInvalidTime(true)
        }
        if (!valid) {
            setTariffValue(tv)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            if (!edit) {
                setLoading(true)
                const lckrTp = tariffShiftValue
                var raw = JSON.stringify({
                    "tariffShiftValue": {
                        "value": lckrTp.value.value.toString().replace(/[^0-9]/g, ""),
                        "diff": lckrTp.diff.value,
                        "startTime": startTime,
                        "endTime": endTime,
                        "tariff": {
                            "id": tariffId
                        },
                        "shift": {
                            "id": shift != null && shift != '' ? shift.value : ''
                        },
                        "lockerType": {
                            "id": lockerType != null && lockerType != '' ? lockerType.value : ''
                        },
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/tariffShiftValues/insertTariffShiftValue'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.refreshTariffShiftValues()
                        } else {
                            childRef.current.openModal()
                        }
                    })
                    .catch(error => setLoading(false))
            } else {
                setLoading(true)
                const lckrTp = tariffShiftValue
                var raw = JSON.stringify({
                    "tariffShiftValue": {
                        "id": id,
                        "value": lckrTp.value.value,
                        "diff": lckrTp.diff.value,
                        "startTime": startTime,
                        "endTime": endTime,
                        "tariff": {
                            "id": tariffId
                        },
                        "shift": {
                            "id": shift != null && shift != '' ? shift.value : ''
                        },
                        "lockerType": {
                            "id": lockerType != null && lockerType != '' ? lockerType.value : ''
                        },
                    },
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/tariffShiftValues/updateTariffShiftValue'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        setLoading(false)
                        if (result.status == 0) {
                            props.refreshTariffShiftValues(event, false)
                        }
                    })
                    .catch(error => setLoading(false))
            }
        }
    }

    const closeModal = (event) => {
        childRef.current.closeModal()
    }

    const afterCloseModal = (event) => {
    }
    const changeLockerType = (selectedOption) => {
        setLockerType(selectedOption)
    }

    const formElementsArray = [];
    for (let key in tariffShiftValue) {
        formElementsArray.push({
            id: key,
            config: tariffShiftValue[key]
        })
    }

    const changeStartTime = (value) => {
        setStartTime(value)
    }

    const changeEndTime = (value) => {
        setEndTime(value)
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="6 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })

    const modalContent = <div>
        <div className='row justify-content-center'>
            رکورد مورد نظر تکراری است
        </div>
        <div className='row justify-content-center mt-3'>
            <Button btnType="Success" clicked={closeModal}>بستن</Button>
        </div>
    </div>

    let lockerTypeList = []
    if (lockerTypes != null && lockerTypes.length != 0) {
        lockerTypes.map(k => {
            lockerTypeList.push({
                value: k.id,
                label: k.description
            })
        })
    }

    return (
        <Fade duration={200} left cascade>
            <div className='row justify-content-center'>
                <div className='tariffShiftValue-cntnr'>
                    <ContentForm headetText='مقادیر تعرفه'>
                        <div className='tariffShiftValue-frm'>
                            <div className='row mr-0 ml-0 p-3'>
                                <TimePicker
                                    onChange={changeStartTime}
                                    value={startTime}
                                    placeHolder="ساعت شروع رزرو"
                                    className={invalidTime && (startTime == null || startTime == '' || startTime == '0:0') ? 'invalid-time' : ''}
                                    col="6"
                                />
                                <TimePicker
                                    onChange={changeEndTime}
                                    value={endTime}
                                    placeHolder="ساعت شروع رزرو"
                                    className={invalidTime && (endTime == null || endTime == '' || endTime == '0:0') ? 'invalid-time' : ''}
                                    col="6"
                                />
                                <Select
                                    name="form-field-name"
                                    value={lockerType}
                                    placeholder="نوع باکس"
                                    options={lockerTypeList}
                                    onChange={changeLockerType}
                                    col="6 mt-2"
                                    className={invalidSelect && (lockerType == null || lockerType == '') ? 'invalid-select' : ''}
                                />
                                {form}
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className='row justify-content-center w-100 mt-3'>
                                <div className='col-6 text-center'>
                                    <Button btnType="General" clicked={(event) => props.toggleNewLockerForm(event, false)}>برگشت</Button>
                                </div>
                                <div className='col-6 text-center'>
                                    <Button btnType="Success" clicked={tariffShiftValueSubmit}>ثبت</Button>
                                </div>
                            </div>
                        </div>
                    </ContentForm>
                </div>
            </div>
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </Fade>
    )
}

export default TariffShiftValueForm